import React from 'react';
import { Building, LayoutGrid, Layers, Cpu } from 'lucide-react';

const ProjectParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  projectTypes,
  complexityLevels,
  locationTypes 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Тип проекта */}
      <div>
        <label htmlFor="projectType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Building className="w-4 h-4 mr-2 text-indigo-500" />
          Тип проекта
        </label>
        <select
          id="projectType"
          name="projectType"
          value={formData.projectType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.projectType ? 'input-error' : ''}`}
        >
          <option value="">Выберите тип проекта</option>
          {projectTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.projectType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.projectType}
          </p>
        )}
      </div>

      {/* Площадь здания */}
      <div>
        <label htmlFor="buildingArea" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <LayoutGrid className="w-4 h-4 mr-2 text-indigo-500" />
          Площадь помещения (м²)
        </label>
        <input
          type="text"
          id="buildingArea"
          name="buildingArea"
          value={formData.buildingArea}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.buildingArea ? 'input-error' : ''}`}
          placeholder="Введите площадь в м²"
        />
        {errors.buildingArea && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.buildingArea}
          </p>
        )}
      </div>

      {/* Количество этажей */}
      <div>
        <label htmlFor="numFloors" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Layers className="w-4 h-4 mr-2 text-indigo-500" />
          Количество этажей
        </label>
        <input
          type="text"
          id="numFloors"
          name="numFloors"
          value={formData.numFloors}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.numFloors ? 'input-error' : ''}`}
          placeholder="Введите количество этажей"
        />
        {errors.numFloors && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.numFloors}
          </p>
        )}
      </div>

      {/* Сложность проекта */}
      <div>
        <label htmlFor="complexity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Cpu className="w-4 h-4 mr-2 text-indigo-500" />
          Сложность проекта
        </label>
        <select
          id="complexity"
          name="complexity"
          value={formData.complexity}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.complexity ? 'input-error' : ''}`}
        >
          <option value="">Выберите уровень сложности</option>
          {complexityLevels.map((level) => (
            <option key={level.id} value={level.id}>
              {level.name}
            </option>
          ))}
        </select>
        {errors.complexity && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.complexity}
          </p>
        )}
      </div>

      {/* Тип местности */}
      <div className="col-span-full">
        <label htmlFor="location" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Тип местности
        </label>
        <select
          id="location"
          name="location"
          value={formData.location}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.location ? 'input-error' : ''}`}
        >
          <option value="">Выберите тип местности</option>
          {locationTypes.map((location) => (
            <option key={location.id} value={location.id}>
              {location.name}
            </option>
          ))}
        </select>
        {errors.location && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.location}
          </p>
        )}
      </div>

      {/* Информационный блок */}
      <div className="col-span-full mt-2 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800 text-sm text-blue-700 dark:text-blue-300">
        <div className="flex items-start">
          <Building className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="font-medium mb-1">Важно о параметрах проекта</h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Указанные параметры напрямую влияют на стоимость. Площадь объекта и его сложность являются ключевыми 
              факторами для точного расчета. Для многоэтажных зданий учитывается дополнительная наценка за каждый этаж.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectParametersSection;